export {
  default as heatedPool,
  ReactComponent as HeatedPool,
} from '@assets/icons/features-and-amenities/heated-pool.svg'    
